import { render, staticRenderFns } from "./ticket-header.vue?vue&type=template&id=1ce28f36&scoped=true"
import script from "./ticket-header.vue?vue&type=script&lang=js"
export * from "./ticket-header.vue?vue&type=script&lang=js"
import style0 from "./ticket-header.vue?vue&type=style&index=0&id=1ce28f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce28f36",
  null
  
)

export default component.exports